import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';

const AISummaryModal = ({ isOpen, data, onClose }) => {

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      titleName='Summary <span>(powered by AI)</span>'
      contentWidth='50%'>
      <div className='d-flex flex-column cursor-none'>
        <p style={{ textAlign: 'justify' }}>{data?.summary}</p>
        <div className='d-flex castleQuestionSearchBox mt-3'>
          <div className='form-chips d-flex align-items-center gap-2 flex-wrap overflow-auto'>
            {data?.keyThemes?.map((keyTheme, index) => (
              <span key={index}>{keyTheme}</span>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

AISummaryModal.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func
};

export default AISummaryModal;
